module.exports = {"tellings":[{"id":1,"name":"Jose","eenheden":"jose@e-force.nl"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Member/Modules/Rapport/TotalTellingData.json
// module id = 1688
// module chunks = 0